import React from 'react';
import PropTypes from 'prop-types';

import Image from '@nerdwallet/react-image';
import { Button, Type as Title } from '@nerdwallet/currency';
import styles from './login.module.less';

const Login = ({
  onSuccess,
  isSignedIn,
  loginModalCopyOverride,
  loginPageCopyOverride,
}) => {
  const flowConfig = loginModalCopyOverride
    ? {
        copyOverrides: {
          signinHeading: loginModalCopyOverride,
        },
      }
    : {};

  return (
    <div className={styles.login__cont}>
      <Image
        className={styles.login__img}
        src="https://www.nerdwallet.com/cdn/brand-site/NW_logo_vert.png"
        alt="NerdWallet Brand"
        backgroundColor="transparent"
        naturalHeight={318}
        naturalWidth={289}
      />
      <Title size="3">
        {loginPageCopyOverride ||
          'You must be signed in with the appropriate credentials to view this page'}
      </Title>
      {!isSignedIn ? (
        <div className={styles.login__btn}>
          <Button
            onClick={() =>
              window.nwapi.ui.showAuthDialog({
                flow: 'basic',
                version: 2,
                authType: 'signin',
                onSuccess,
                flowConfig,
              })
            }
          >
            SIGN IN OR CREATE ACCOUNT
          </Button>
        </div>
      ) : null}
    </div>
  );
};

Login.displayName = 'Login';

Login.propTypes = {
  onSuccess: PropTypes.string,
  isSignedIn: PropTypes.bool,
  loginModalImgOverride: PropTypes.string,
  loginModalCopyOverride: PropTypes.string,
  loginPageCopyOverride: PropTypes.string,
};

export default Login;
